import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { BulkUploadPageComponent } from './bulk-upload-page.component';
import { EmployeeFileUploadModule } from './employee-file-upload/employee-file-upload.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.bulkUpload',
    url: '/bulkUpload',
    component: BulkUploadPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      uploadType: null
    }
  }
];

@NgModule({
  declarations: [BulkUploadPageComponent],
  imports: [
    CommonModule,
    EmployeeFileUploadModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [BulkUploadPageComponent],
  entryComponents: [BulkUploadPageComponent]
})
export class BulkUploadPageModule { }
